import { render, staticRenderFns } from "./loanFailureOrder.vue?vue&type=template&id=eec4bafa&scoped=true&"
import script from "./loanFailureOrder.vue?vue&type=script&lang=js&"
export * from "./loanFailureOrder.vue?vue&type=script&lang=js&"
import style0 from "./loanFailureOrder.vue?vue&type=style&index=0&id=eec4bafa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec4bafa",
  null
  
)

export default component.exports